import { Spin } from 'antd';

import styles from './Loader.module.scss';

type TProps = {
  isSpinning: boolean;
  description?: string;
};

export const Loader = ({ isSpinning, description = 'Обработка' }: TProps) => (
  <Spin
    spinning={isSpinning}
    size="large"
    fullscreen
    description={<div className={styles.loader}>{description}</div>}
  >
    <div />
  </Spin>
);
